// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/app/assets/img/mail-bg1.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client_slider .headline .h3 {
  font-family: Lato, sans-serif;
  text-align: center;
  font-size: 2.5rem; 
  font-weight: bold;
  margin-bottom: 30px;
}

.client_slider .item img {
  max-width: 150px;
  transition: transform 0.3s ease-in-out; 
  cursor: pointer; 
}

.client_slider .item img:hover {
  transform: scale(1.2); 
}

.mail-section .headline .h3 {
  font-family: Lato, sans-serif;
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 10px;
}

.mail-section .sub-headline {
  text-align: center;
  font-size: 1.2rem;
  margin-bottom: 20px;
}


.mail-section .theme-btn:hover {
  background-color: #0056b3;
}

.mail-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  margin-top: 20px;
}


.hidden {
  display: none;
}

.visible {
  display: block;
}

.testimonial {
  margin-top: -86px;
}

.testimonial .headline {
  text-align: center;
}

.testimonial .headline .sub-headline {
  font-size: 1.2rem;
  margin-bottom: 10px;
}

.testimonial .client-slide .checked {
  color: #ffd700;
}

.testimonial .client-slide .normal {
  font-size: 1rem;
  line-height: 1.5;
  margin: 10px 0;
  /* max-height: 80px;  */
  min-height: 100px; /* Ensures enough space */
  max-height: none; /* Allow full height dynamically */
  overflow: visible;
}

.testimonial .client-slide .read-more {
  display: inline-block;
  color: #007bff;
  font-size: 0.9rem;
  cursor: pointer;
  margin-top: 10px;
  text-decoration: underline;
}

.testimonial .client-slide .normal.expanded {
  max-height: none;
  overflow: visible;
}

.testimonial .client-slide .item .normal.expanded {
  max-height: none; 
  overflow: visible;
}

.testimonial .client-slide .title {
  font-weight: bold;
  font-size: 1.1rem;
  margin-top: 10px;
}

.swiper-button-prev::after, .swiper-button-next::after{
  font-size: 10px!important;
  z-index: 10 !important;
 
}
/* .swiper-button-next, .swiper-button-prev {
  z-index: 10 !important;
} */

.testimonial .client-slide .project {
  font-size: 0.9rem;
  color: #666;
}

.client-slide .fa-star {
  margin-right: 2px;
}

.client-slide .fa-star.checked {
  color: #ffd700;
}

.client-slide .item {
  max-width: 500px;
  margin: 0 auto;
  padding: 20px;
}

.listing-home {
  overflow-x: hidden;
  gap: 20px; 
  scroll-behavior: smooth; 
}

.project-card:hover {
  transform: translateY(-5px);
}

.project-card-image {
  width: 100%;
  height: 15.625rem;
  border-radius: 8px;
}

.project-card-title {
  font-family: lato, sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
  color: #000;
  margin: 0;
  padding: 20px 0 0;
  min-height:80px;
}

.project-card-location {
  color: #282c35ad;
  font-weight: 700;
  /* min-height: 61px; */
  font-size: 12px;
  padding: 5px 0 20px;
  margin: 0;
}

.project-card-details {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}

.project-card-details span > :nth-child(1) {
  color: #2067d1;
}

a {
  text-decoration: none;
}

.project-card-details span span {
  color: black;
  font-weight: 500;
  font-size: small;
}

.project-card-price {
  font-size: 13px;
  font-weight: bold;
  color: #1d1f21;
}

.project-card-footer {
  display: flex;
  justify-content: space-between;
}

.project-card-details-btn {
  font-family: lato, sans-serif;
  border-radius: 5px;
  padding: 5px 10px;
  font-weight: 600;
  color: #fff !important;
  font-size: 12px;
  background-color: #2067d1;
  border: 2px solid #2067d1;
  text-decoration: none;
  display: block;
  width: fit-content;
  margin-top: 0;
  text-transform: uppercase;
}

.project-card-details-btn:hover {
  background-color: #0056b3;
}

.loader-container {
  position: absolute; 
  top: 50%; 
  left: 50%;
  transform: translate(-50%, -50%); 
  z-index: 1000; 
  width: 100%; 
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader {
  font-size: 1.5rem;
  font-weight: bold;
  color: #000;
}

.listing-home {
  position: relative; 
}

.main-con {
  position: relative; 
}

h1,
p {
  position: relative;
  z-index: 1;
}

.btn {
  position: relative; 
  z-index: 1;
}

.scroll-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: #007bff;
  color: white;
  padding: 10px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

.scroll-button:hover {
  background-color: #0056b3;
}

.scroll-button-left {
  left: 10px;
}

.scroll-button-right {
  right: 10px;
}


.theme-btn {
  font-family: 'Lato', sans-serif;
  border-radius: 8px;
  padding: 5px 20px;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff !important;
  background-color: #2067d1;
  border: 2px solid #2067d1;
  text-decoration: none;
  display: block;
  width: fit-content;
  margin-top: 15px;
}


.read-more-span {
  color: #2067d1;
  cursor: pointer;
  font-weight: bold;
  margin-left: 5px;
  font-size: 10px;
}

.read-more-span:hover {
  text-decoration: underline;
}

.normal {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.normal.expanded {
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
}


.premium-tag {
  background-color: #2067d1;
  color: white;
  font-weight: bold;
  padding: 5px 10px;
  border-radius: 5px;
  position: absolute;
  top:20px;
  left: 35px;
  font-size: 10px;
  text-transform: uppercase;
  /* z-index: 10; */
}
`, "",{"version":3,"sources":["webpack://./src/app/components/styles/css/home.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yDAAyD;EACzD,gBAAgB;AAClB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB,EAAE,yBAAyB;EAC5C,gBAAgB,EAAE,kCAAkC;EACpD,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;;AAExB;AACA;;GAEG;;AAEH;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EAGd,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB","sourcesContent":[".client_slider .headline .h3 {\n  font-family: Lato, sans-serif;\n  text-align: center;\n  font-size: 2.5rem; \n  font-weight: bold;\n  margin-bottom: 30px;\n}\n\n.client_slider .item img {\n  max-width: 150px;\n  transition: transform 0.3s ease-in-out; \n  cursor: pointer; \n}\n\n.client_slider .item img:hover {\n  transform: scale(1.2); \n}\n\n.mail-section .headline .h3 {\n  font-family: Lato, sans-serif;\n  font-size: 2.5rem;\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.mail-section .sub-headline {\n  text-align: center;\n  font-size: 1.2rem;\n  margin-bottom: 20px;\n}\n\n\n.mail-section .theme-btn:hover {\n  background-color: #0056b3;\n}\n\n.mail-background {\n  background-image: url(\"/src/app/assets/img/mail-bg1.png\");\n  margin-top: 20px;\n}\n\n\n.hidden {\n  display: none;\n}\n\n.visible {\n  display: block;\n}\n\n.testimonial {\n  margin-top: -86px;\n}\n\n.testimonial .headline {\n  text-align: center;\n}\n\n.testimonial .headline .sub-headline {\n  font-size: 1.2rem;\n  margin-bottom: 10px;\n}\n\n.testimonial .client-slide .checked {\n  color: #ffd700;\n}\n\n.testimonial .client-slide .normal {\n  font-size: 1rem;\n  line-height: 1.5;\n  margin: 10px 0;\n  /* max-height: 80px;  */\n  min-height: 100px; /* Ensures enough space */\n  max-height: none; /* Allow full height dynamically */\n  overflow: visible;\n}\n\n.testimonial .client-slide .read-more {\n  display: inline-block;\n  color: #007bff;\n  font-size: 0.9rem;\n  cursor: pointer;\n  margin-top: 10px;\n  text-decoration: underline;\n}\n\n.testimonial .client-slide .normal.expanded {\n  max-height: none;\n  overflow: visible;\n}\n\n.testimonial .client-slide .item .normal.expanded {\n  max-height: none; \n  overflow: visible;\n}\n\n.testimonial .client-slide .title {\n  font-weight: bold;\n  font-size: 1.1rem;\n  margin-top: 10px;\n}\n\n.swiper-button-prev::after, .swiper-button-next::after{\n  font-size: 10px!important;\n  z-index: 10 !important;\n \n}\n/* .swiper-button-next, .swiper-button-prev {\n  z-index: 10 !important;\n} */\n\n.testimonial .client-slide .project {\n  font-size: 0.9rem;\n  color: #666;\n}\n\n.client-slide .fa-star {\n  margin-right: 2px;\n}\n\n.client-slide .fa-star.checked {\n  color: #ffd700;\n}\n\n.client-slide .item {\n  max-width: 500px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.listing-home {\n  overflow-x: hidden;\n  gap: 20px; \n  scroll-behavior: smooth; \n}\n\n.project-card:hover {\n  transform: translateY(-5px);\n}\n\n.project-card-image {\n  width: 100%;\n  height: 15.625rem;\n  border-radius: 8px;\n}\n\n.project-card-title {\n  font-family: lato, sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 30px;\n  color: #000;\n  margin: 0;\n  padding: 20px 0 0;\n  min-height:80px;\n}\n\n.project-card-location {\n  color: #282c35ad;\n  font-weight: 700;\n  /* min-height: 61px; */\n  font-size: 12px;\n  padding: 5px 0 20px;\n  margin: 0;\n}\n\n.project-card-details {\n  display: flex;\n  justify-content: space-between;\n  margin: 10px 0;\n}\n\n.project-card-details span > :nth-child(1) {\n  color: #2067d1;\n}\n\na {\n  text-decoration: none;\n}\n\n.project-card-details span span {\n  color: black;\n  font-weight: 500;\n  font-size: small;\n}\n\n.project-card-price {\n  font-size: 13px;\n  font-weight: bold;\n  color: #1d1f21;\n}\n\n.project-card-footer {\n  display: flex;\n  justify-content: space-between;\n}\n\n.project-card-details-btn {\n  font-family: lato, sans-serif;\n  border-radius: 5px;\n  padding: 5px 10px;\n  font-weight: 600;\n  color: #fff !important;\n  font-size: 12px;\n  background-color: #2067d1;\n  border: 2px solid #2067d1;\n  text-decoration: none;\n  display: block;\n  width: fit-content;\n  margin-top: 0;\n  text-transform: uppercase;\n}\n\n.project-card-details-btn:hover {\n  background-color: #0056b3;\n}\n\n.loader-container {\n  position: absolute; \n  top: 50%; \n  left: 50%;\n  transform: translate(-50%, -50%); \n  z-index: 1000; \n  width: 100%; \n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.loader {\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: #000;\n}\n\n.listing-home {\n  position: relative; \n}\n\n.main-con {\n  position: relative; \n}\n\nh1,\np {\n  position: relative;\n  z-index: 1;\n}\n\n.btn {\n  position: relative; \n  z-index: 1;\n}\n\n.scroll-button {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: #007bff;\n  color: white;\n  padding: 10px;\n  border-radius: 50%;\n  cursor: pointer;\n  z-index: 1;\n}\n\n.scroll-button:hover {\n  background-color: #0056b3;\n}\n\n.scroll-button-left {\n  left: 10px;\n}\n\n.scroll-button-right {\n  right: 10px;\n}\n\n\n.theme-btn {\n  font-family: 'Lato', sans-serif;\n  border-radius: 8px;\n  padding: 5px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #fff !important;\n  background-color: #2067d1;\n  border: 2px solid #2067d1;\n  text-decoration: none;\n  display: block;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  margin-top: 15px;\n}\n\n\n.read-more-span {\n  color: #2067d1;\n  cursor: pointer;\n  font-weight: bold;\n  margin-left: 5px;\n  font-size: 10px;\n}\n\n.read-more-span:hover {\n  text-decoration: underline;\n}\n\n.normal {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.normal.expanded {\n  overflow: visible;\n  text-overflow: clip;\n  white-space: normal;\n}\n\n\n.premium-tag {\n  background-color: #2067d1;\n  color: white;\n  font-weight: bold;\n  padding: 5px 10px;\n  border-radius: 5px;\n  position: absolute;\n  top:20px;\n  left: 35px;\n  font-size: 10px;\n  text-transform: uppercase;\n  /* z-index: 10; */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
